export function setDraggable({ el, startDrag, endDrag }) {
  const pos = { startTop: 0, startLeft: 0, startX: 0, startY: 0 };
  el.addEventListener('mousedown', mouseDownHandler);

  // Disable dragging for links in the scroll elements so that
  // dragging makes the container scroll instead of dragging ghost
  // elements around
  const links = [].slice.call(el.querySelectorAll('a'));
  links.forEach(link => {
    let didDrag = false;
    link.addEventListener('dragstart', e => {
      e.preventDefault();
      didDrag = true;
    });
    link.addEventListener('click', e => {
      if (didDrag) {
        e.preventDefault();
      }
      didDrag = false;
    });
  });

  function mouseDownHandler(e) {
    // The current scroll
    pos.startLeft = el.scrollLeft;
    pos.startTop = el.scrollTop;
    // Get the current mouse position
    pos.startX = e.clientX;
    pos.startY = e.clientYl;

    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
    el.style['scroll-snap-type'] = 'none';

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);

    if (startDrag) startDrag();
  }
  function mouseMoveHandler(e) {
    // How far the mouse has been moved
    const dx = e.clientX - pos.startX;
    const dy = e.clientY - pos.startY;

    // Scroll the element
    el.scrollTop = pos.startTop - dy;
    el.scrollLeft = pos.startLeft - dx;
  }
  function mouseUpHandler() {
    el.style.cursor = 'grab';
    el.style.removeProperty('user-select');
    el.style.removeProperty('scroll-snap-type');

    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

    if (endDrag) endDrag();
  }
}
